import { I as Icon, _ as _extends } from './Icon-f29ff1c6.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Warning = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M13.7424 3.0771c-.7179-1.4362-2.7669-1.4362-3.4848 0L2.2082 19.18C1.5605 20.4756 2.5024 22 3.9506 22h16.0988c1.4482 0 2.3901-1.5244 1.7424-2.82L13.7424 3.0771zm-2.7789 6.0384c0-.5523.4477-1 1-1s1 .4477 1 1v5.1129c0 .5523-.4477 1-1 1s-1-.4477-1-1V9.1155zm2 8.6532c0 .5612-.4477 1.0161-1 1.0161s-1-.4549-1-1.0161c0-.5612.4477-1.0161 1-1.0161s1 .4549 1 1.0161z",
      clipRule: "evenodd"
    }),
    stroke: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      d: "M10.9636 9.1172c0-.5523.4477-1 1-1s1 .4477 1 1V14.23c0 .5523-.4477 1-1 1s-1-.4477-1-1V9.1172zM12.9636 17.7703c0 .5612-.4477 1.0161-1 1.0161s-1-.4549-1-1.0161c0-.5612.4477-1.0161 1-1.0161s1 .4549 1 1.0161z"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M10.2576 3.0771c.7179-1.4362 2.7669-1.4362 3.4848 0L21.7918 19.18c.6477 1.2956-.2942 2.82-1.7424 2.82H3.9506c-1.4482 0-2.39-1.5244-1.7424-2.82l8.0494-16.1029zM4.0342 20L12 4.0645 19.9658 20H4.0342z",
      clipRule: "evenodd"
    }))
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Warning.displayName = "WarningIcon";

export { Warning, Warning as default };
